import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InterestRegisterFacadeService } from 'app/services/api/interest-register/interest-register.service';
import {
    ALL_INTEREST_REGISTER_ENTRIES_CARD,
    INTEREST_REGISTER_ENTRY_TYPES,
    InterestRegisterEntryTypeConfig,
    MY_INTEREST_REGISTER_ENTRIES_CARD,
} from 'common/constants/assists-interest-register.constants';

@Component({
    selector: 'app-assists-interest-register',
    templateUrl: './assists-interest-register.component.html',
    styleUrls: ['./assists-interest-register.component.scss'],
})
export class AssistsInterestRegisterComponent implements OnInit {
    entryTypes = INTEREST_REGISTER_ENTRY_TYPES;
    myEntriesCard = MY_INTEREST_REGISTER_ENTRIES_CARD;
    allEntriesCard = ALL_INTEREST_REGISTER_ENTRIES_CARD;

    canViewAllEntries = false;

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly facade: InterestRegisterFacadeService
    ) {}

    ngOnInit(): void {
        this.facade.readAccess().subscribe({
            next: (access) => {
                this.canViewAllEntries = access.canReadAll;
            },
        });
    }

    selectEntryType(entryType: InterestRegisterEntryTypeConfig): void {
        this.router.navigate(['ny-skraning', entryType.type], { relativeTo: this.route });
    }

    goToMyEntries(): void {
        this.router.navigate(['minar-skraningar'], { relativeTo: this.route });
    }

    goToAllEntries(): void {
        this.router.navigate(['skraningar'], { relativeTo: this.route });
    }

    goToAssistsOverview(): void {
        this.router.navigate(['../yfirlit'], { relativeTo: this.route });
    }
}
